import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import answerimg from '../../images/answer.png'
import s from '../../services/allservices.jsx'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import '../../stylesheet/forcechangepassword.css'
import '../../stylesheet/changepassword.css'
import LoaderSmall from "../loader/loadersmall.jsx"
import * as actions from '../../actions/actions.jsx'
import { connect } from 'react-redux';
import logo from "../../images/GM-Cabs-card-logo.jpg";
import $ from 'jquery'
import GuestNav from '../navigation/guestnavbar.jsx'
import {
    Link, withRouter
} from 'react-router-dom';

const styles = {
    button: {
        // margin: 12,
        marginTop: 20,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        keyRecieved: state.publicKey.keyRecieved,
    })

const mapDispatchToProps = dispatch =>
    ({
        fetchPublicKey(keyRecieved) {
            dispatch(
                actions.publicKeyAction(keyRecieved)
            )
        }
    })
const JSEncrypt = window.JSEncrypt

class ForceChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            correctPassword: true,
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
        }
    }

    onChange = (e, value) => this.setState({ [e.target.name]: e.target.value }, () => {
    })
    validatePassword(e) {
        e.preventDefault();
        var passwd = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+-,'#\$%\^&\*])(?=.{8,})");
        if (e.target.name === "newPassword") {
            if ((passwd.test(e.target.value))) {
                this.setState({
                    [e.target.name]: e.target.value,
                    correctPassword: true
                })

            }

            else {
                this.setState({
                    correctPassword: false
                })
            }
        }

    }
    componentDidMount() {
        $(".toggle-password").click(function () {

            $(this).toggleClass("fa-eye fa-eye-slash");
            var input = $($(this).attr("toggle"));
            if (input.attr("type") == "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });

    }
    handleChange = (e, value) => {

        var myInput = document.getElementById("psw");
        var letter = document.getElementById("letter");
        var capital = document.getElementById("capital");
        var number = document.getElementById("number");
        var length = document.getElementById("length");
        var spec = document.getElementById("sp");

        // // When the user clicks on the password field, show the message box
        myInput.onfocus = function () {
            document.getElementById("errmessagebody").style.display = "block";
        }
        // When the user clicks outside of the password field, hide the message box
        myInput.onblur = function () {
            document.getElementById("errmessagebody").style.display = "none";
        }
        myInput.onkeyup = function () {
            // Validate lowercase letters
            var lowerCaseLetters = /[a-z]/g;
            if (myInput.value.match(lowerCaseLetters)) {
                letter.classList.remove("invalid");
                letter.classList.add("valid");
            } else {
                letter.classList.remove("valid");
                letter.classList.add("invalid");
            }

            // Validate capital letters
            var upperCaseLetters = /[A-Z]/g;
            if (myInput.value.match(upperCaseLetters)) {
                capital.classList.remove("invalid");
                capital.classList.add("valid");
            } else {
                capital.classList.remove("valid");
                capital.classList.add("invalid");
            }

            // Validate numbers
            var numbers = /[0-9]/g;
            if (myInput.value.match(numbers)) {
                number.classList.remove("invalid");
                number.classList.add("valid");
            } else {
                number.classList.remove("valid");
                number.classList.add("invalid");
            }

            // Validate length
            if (myInput.value.length >= 8) {
                length.classList.remove("invalid");
                length.classList.add("valid");
            } else {
                length.classList.remove("valid");
                length.classList.add("invalid");
            }

            //special character match
            var spe = /(?=.*[!@.+-,'#\$%\^&\*])/g;
            if (myInput.value.match(spe)) {
                spec.classList.remove("invalid");
                spec.classList.add("valid");
            } else {
                spec.classList.remove("valid");
                spec.classList.add("invalid");
            }
        }
        var passwd = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+-,'#\$%\^&\*])(?=.{8,})");
        if (e.target.name === "newPassword") {
            if ((passwd.test(e.target.value))) {
                this.setState({
                    [e.target.name]: e.target.value,
                    correctPassword: true
                })

            }

            else {
                this.setState({
                    correctPassword: false
                })
            }
        }


    }

    handleSubmit1 = () => {
        this.props.history.push('/');
    }

    handleSubmit = () => {
        const { oldPassword, newPassword, confirmPassword } = this.state
        let _this = this
        const { publicKey } = this.props
        if (publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);
            let _this = this

            const state = {
                applicationId: "gmcabs",
                confirmPassword: encrypt.encrypt(confirmPassword),
                newPassword: encrypt.encrypt(newPassword),
                oldPassword: encrypt.encrypt(oldPassword),
                accountId: encrypt.encrypt(localStorage.getItem("accountId"))
            }
            this.setState({
                loader: true
            })
            let token = "Token " + localStorage.getItem('token')
            if (oldPassword !== '' && newPassword !== '' && confirmPassword !== '') {
                if (newPassword === confirmPassword) {
                    fetch(s.change_password, {
                        method: 'POST',
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }),
                        body: JSON.stringify(state)
                    })
                        .then(response => {
                            if (response.status === 200 || response.status === 201) {
                                toast.success(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });
                                this.setState({
                                    loader: false
                                })
                                setTimeout(function () {
                                    _this.props.history.push('/home');
                                }, 3000);
                            } else {
                                toast.error(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });
                                this.setState({
                                    loader: false
                                })
                                // setTimeout(function () { window.location.reload(true); }, 2000);

                            }
                        })
                } else {
                    toast.error('New Password and Confirm Password should be same'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    };
                    this.setState({
                        loader: false
                    })
                }
            } else {
                toast.error('Please enter data in required fields'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                };
                this.setState({
                    loader: false
                })
            }

        }
    }

    render() {
        const { correctPassword } = this.state
        const height = $(window).height() - 108;
        return (
            <div className="col-md-12 forcechangepwd" style={{ minHeight: height }}>
                <GuestNav />
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <div className="row">
                    <div className="col-md-3" style={{ marginTop: "100px", marginLeft: "50px" }}>
                        <div id="errmessagebody" >
                            <span style={{ fontSize: "14px", marginLeft: "10px" }}> Password must contain following:</span><br />
                            <div style={{ marginTop: "8px", padding: "0px 15px" }}>
                                <span id="length" className="invalid">At least 8 to 15 characters </span><br />
                                <span id="capital" className="invalid">At least one upper case alphabet</span><br />
                                <span id="letter" className="invalid">At least one lower case alphabet</span><br />
                                <span id="sp" className="invalid">At least one special character ( ! @ # $ % ^ & * )</span><br />
                                <span id="number" className="invalid">At least one number</span><br />

                            </div>
                        </div>
                    </div>
                    <div className="col-md-7" style={{ marginTop: "100px" }}>
                        <div className="tile box-shadow-style" >
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="summary-header">
                                        <div className="row">
                                            <div className="col-md-6" style={{ fontSize: 18 + "px !important" }}>
                                                <span>Change Password</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="offset-md-3 col-md-6 col-sm-12">
                                    <div className="row input-group" >
                                        <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-8" >
                                            <TextField
                                                hintText="Start Typing.."
                                                floatingLabelText="Current Password"
                                                type="password"
                                                maxLength="15"
                                                name="oldPassword"
                                                className="input-width required"
                                                onChange={this.onChange}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <div className="row input-group" >
                                        <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-7" >
                                            <TextField
                                                hintText="Start Typing.."
                                                floatingLabelText="New Password"
                                                type="password"
                                                id="psw"
                                                maxLength="15"
                                                name="newPassword"
                                                className="input-width required"
                                                onFocus={this.handleChange.bind(this)}
                                                onChange={this.handleChange.bind(this)}
                                                onBlur={this.validatePassword.bind(this)}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                errorText={correctPassword ? null : "please check help button."}
                                            />
                                            <span className="col-sm-1" toggle="#psw" className="fa fa-fw fa-eye field-icon toggle-password" style={{ top: "35px", right: "16px", position: "absolute", color: "#333" }}></span>
                                        </div>
                                        <div className="col-sm-2 tooltip" style={{ top: "35px" }}>
                                            <i className="fa fa-question-circle" aria-hidden="true"></i>
                                            <span className="tooltiptext" style={{ fontSize: "12px" }} >Your Password must contain at least 8 character, one number, one lowercase ,special character and one uppercase letter </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row input-group" >
                                        <div className="col-sm-2 input-icon" >
                                            <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                        </div>
                                        <div className="col-sm-7" >
                                            <TextField
                                                hintText="Start Typing.."
                                                floatingLabelText="Confirm Password"
                                                type="password"
                                                id="loginpassword"
                                                maxLength="15"
                                                name="confirmPassword"
                                                className="input-width required"
                                                style={{ zIndex: "0" }}
                                                onChange={this.onChange}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                            />
                                            <span className="col-sm-1" toggle="#loginpassword" className="fa fa-fw fa-eye field-icon toggle-password" style={{ top: "35px", right: "16px", position: "absolute", color: "#333" }}></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="row">
                                        <div className="offset-sm-4 col-sm-2" style={{ marginRight: "40px" }}>
                                            <RaisedButton
                                                label="Cancel"
                                                className="pull-right"
                                                // style={styles.button}
                                                backgroundColor="#333"
                                                labelColor="#fff"
                                                onClick={this.handleSubmit1.bind(this)}
                                                style={{ marginTop: "10px" }}
                                            />
                                        </div>

                                        <div className="col-sm-1">
                                            <RaisedButton
                                                label="Change"
                                                className="pull-right"
                                                // style={styles.button}
                                                backgroundColor="#333"
                                                labelColor="#fff"
                                                onClick={this.handleSubmit.bind(this)}
                                                style={{ marginTop: "10px" }}
                                            />
                                        </div>
                                        {this.state.loader === true &&
                                            <div className="col-sm-1" style={{ marginTop: "-17px", width: "30% !mportant" }} >
                                                <LoaderSmall />
                                            </div>}

                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForceChangePassword));


// WEBPACK FOOTER //
// ./src/components/forcechangepassword/forcechangepassword.jsx